// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "static/css/main.0c4ed348.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"05a86346","4655":"05a86346","6685":"05a86346","8582":"05a86346","9702":"05a86346"}[chunkId] + ".chunk.css";
};